const LegendEntries = require('okCharts/LegendEntries');

module.exports = LegendEntries;
